<template>

    <div v-cloak class="container-fluid">

        <div class="row">
            <div class="col">
                <h4 class="text-portal-soft-black pt-2">{{cmsContentBlocks['templateSelector.MainPage.Header']}}</h4>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col">
                <h5 class="text-portal-soft-black" v-once>{{cmsContentBlocks['radiologyExamsCopy.Header']}}</h5>
            </div>
        </div>

        <div class="row mt-mb-3">
            <div class="col">
                <span class="text-portal-soft-black" v-once v-html="cmsContentBlocks['radiologyExamsCopy.IntroductionText1']"></span>
            </div>
        </div>

        <div class="row mt-mb-3">
            <div class="col">
                <span class="text-portal-soft-black" v-once>{{cmsContentBlocks['radiologyExamsCopy.IntroductionText2']}}</span>
            </div>
        </div>

        <div class="row mt-mb-4">
            <div class="col">
                <span class="text-portal-soft-red" v-once>{{cmsContentBlocks['allFieldsAreRequiredHeaderImportant']}}</span>
                <span class="text-portal-soft-black" v-once>{{cmsContentBlocks['allFieldsAreRequiredHeader']}}</span>
            </div>
        </div>

        <div v-if="!isPatient" class="row mt-3">
            <div class="col-12">
                <strong>{{cmsContentBlocks['radiologyExamsCopy.YourInformationLabel']}}</strong>
                <hr />
            </div>
        </div>

        <div v-if="!isPatient" class="row mt-3">
            <div class="col col-sm-12">
                <strong>{{cmsContentBlocks['radiologyExamsCopy.PatientFullNameLabel']}}</strong> {{patientContactInfo.patientFullName}}
            </div>
        </div>

        <div v-if="!isPatient" class="row mt-3">
            <div class="col col-sm-12">
                <strong>{{cmsContentBlocks['radiologyExamsCopy.PatientEmailAddressLabel']}}</strong> {{messageModel.patientEmailAddress}}
            </div>
        </div>

        <div v-if="!isPatient" class="row mt-3">
            <div class="col col-sm-12">
                <strong>{{cmsContentBlocks['radiologyExamsCopy.RelationshiptoPatientLabel']}} </strong> {{patientContactInfo.proxyRelationship}}
            </div>
        </div>

        <div v-if="!isPatient" class="row mt-mb-2">
            <div class="col-12">
                <hr />
            </div>
        </div>

        <div class="row mt-2">
            <div class="col flex-display">
                <span v-if="isPatient"><strong>{{cmsContentBlocks['radiologyExamsCopy.YourInformationLabel']}}</strong></span>
                <span v-if="!isPatient"><strong>{{cmsContentBlocks['radiologyExamsCopy.PatientInformationLabel']}}</strong></span>
                <hr />
            </div>
        </div>

        <div class="row mt-2">
            <div class="col col-sm-12">
                <strong>{{cmsContentBlocks['radiologyExamsCopy.PatientFullNameLabel']}}</strong>
                <span v-if="isPatient">{{patientContactInfo.patientFullName}}</span>
                <span v-if="!isPatient">{{patientContactInfo.proxyFullName}}</span>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col">
                <div class="row">
                    <div class="col-3 col-sm-3">
                        <strong>{{cmsContentBlocks['radiologyExamsCopy.DOBLabel']}} </strong>
                        <span v-if="isPatient">{{patientContactInfo.patientDOB | formatToShortDate}}</span>
                        <span v-if="!isPatient">{{patientContactInfo.proxyDOB | formatToShortDate}}</span>
                    </div>
                    <div class="col-3 col-sm-3">
                        <strong>{{cmsContentBlocks['radiologyExamsCopy.MRNLabel']}} </strong>
                        <span v-if="isPatient">{{patientContactInfo.patientMRN}}</span>
                        <span v-if="!isPatient">{{patientContactInfo.proxyMRN}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-3 mb-2" v-show="isPatient">
            <div class="col">
                <label for="txtPatientPhoneNumber">
                    <strong>{{cmsContentBlocks['radiologyExamsCopy.PhoneNumberLabel']}}<span class="required"> *</span></strong>
                </label>
            </div>
        </div>
        <div class="row" v-show="isPatient">
            <div class="col">
                <div class="form-group">
                    <input id="txtPatientPhoneNumber" maxlength="50" v-error-message="{ errorModel: 'errorModel.patientPhoneNumber' }" v-model="messageModel.patientPhoneNumber" :placeholder="cmsContentBlocks['radiologyExamsCopy.PhoneNumber.Placeholder']" class="form-control" />
                    <span class="invalid-feedback is-invalid">{{errorModel.patientPhoneNumber | firstError}}</span>
                </div>
            </div>
        </div>

        <div class="row mt-3 mb-2" v-show="!isPatient">
            <div class="col">
                <label for="txtProxyPhoneNumber">
                    <strong>{{cmsContentBlocks['radiologyExamsCopy.PhoneNumberLabel']}}<span class="required"> *</span></strong>
                </label>
            </div>
        </div>
        <div class="row" v-show="!isPatient">
            <div class="col">
                <div class="form-group">
                    <input id="txtProxyPhoneNumber" maxlength="50" v-error-message="{ errorModel: 'errorModel.proxyPhoneNumber' }" v-model="messageModel.proxyPhoneNumber" :placeholder="cmsContentBlocks['radiologyExamsCopy.PhoneNumber.Placeholder']" class="form-control" />
                    <span class="invalid-feedback is-invalid">{{errorModel.proxyPhoneNumber | firstError}}</span>
                </div>
            </div>
        </div>

        <div class="row text-portal-soft-black mt-3 mb-2">
            <div class="col" v-once>
                <label for="cmbDeliveryType">
                    <strong>{{cmsContentBlocks['radiologyExamsCopy.DeliveryTypeLabel']}} <span class="required"> *</span></strong>
                </label>
            </div>
        </div>
        <div class="row text-portal-soft-black">
            <div class="col-4">
                <select2-component id="cmbDeliveryType" title="Delivery Type" v-error-message="{ errorModel: 'errorModel.radiologyExamsDeliveryType' }" v-model="messageModel.radiologyExamsDeliveryType" :options="radiologyExamsDeliveryValues" :allowclear="false" :addblankentry="false" class="form-control">
                </select2-component>
                <span class="invalid-feedback is-invalid">{{errorModel.radiologyExamsDeliveryType | firstError}}</span>
            </div>
        </div>

        <div class="row mt-3 mb-2" v-show="(!showMailingAddress && isPatient)">
            <div class="col">
                <label for="txtPatientEmailAddress">
                    <strong>{{cmsContentBlocks['radiologyExamsCopy.EmailAddressLabel']}}<span class="required"> *</span></strong>
                </label>
            </div>
        </div>
        <div class="row" v-show="(!showMailingAddress && isPatient)">
            <div class="col">
                <div class="form-group">
                    <input id="txtPatientEmailAddress" maxlength="50" v-error-message="{ errorModel: 'errorModel.patientEmailAddress' }" v-model="messageModel.patientEmailAddress" placeholder="Enter Email Address" class="form-control" />
                    <span class="invalid-feedback is-invalid">{{errorModel.patientEmailAddress | firstError}}</span>
                </div>
            </div>
        </div>

        <div class="row mt-3 mb-2" v-show="(!showMailingAddress && !isPatient)">
            <div class="col">
                <label for="txtProxyEmailAddress">
                    <strong>{{cmsContentBlocks['radiologyExamsCopy.EmailAddressLabel']}}<span class="required"> *</span></strong>
                </label>
            </div>
        </div>
        <div class="row" v-show="(!showMailingAddress && !isPatient)">
            <div class="col">
                <div class="form-group">
                    <input id="txtProxyEmailAddress" maxlength="50" v-error-message="{ errorModel: 'errorModel.proxyEmailAddress' }" v-model="messageModel.proxyEmailAddress" placeholder="Enter Email Address" class="form-control" />
                    <span class="invalid-feedback is-invalid">{{errorModel.proxyEmailAddress | firstError}}</span>
                </div>
            </div>
        </div>

        <div class="row mt-3 mb-2" v-show="(showMailingAddress && isPatient)">
            <div class="col">
                <label for="txtPatientMailingAddress">
                    <strong>{{cmsContentBlocks['radiologyExamsCopy.MailingAddressLabel']}}<span class="required"> *</span></strong>
                </label>
            </div>
        </div>
        <div class="row" v-show="(showMailingAddress && isPatient)">
            <div class="col">
                <div class="form-group">
                    <input id="txtPatientMailingAddress" maxlength="250" v-error-message="{ errorModel: 'errorModel.patientMailingAddress' }" v-model="messageModel.patientMailingAddress" placeholder="Enter Mailing Address" class="form-control" />
                    <span class="invalid-feedback is-invalid">{{errorModel.patientMailingAddress | firstError}}</span>
                </div>
            </div>
        </div>

        <div class="row mt-3 mb-2" v-show="(showMailingAddress && !isPatient)">
            <div class="col">
                <label for="txtProxyMailingAddress">
                    <strong>{{cmsContentBlocks['radiologyExamsCopy.MailingAddressLabel']}}<span class="required"> *</span></strong>
                </label>
            </div>
        </div>
        <div class="row" v-show="(showMailingAddress && !isPatient)">
            <div class="col">
                <div class="form-group">
                    <input id="txtProxyMailingAddress" maxlength="250" v-error-message="{ errorModel: 'errorModel.proxyMailingAddress' }" v-model="messageModel.proxyMailingAddress" placeholder="Enter Mailing Address" class="form-control" />
                    <span class="invalid-feedback is-invalid">{{errorModel.proxyMailingAddress | firstError}}</span>
                </div>
            </div>
        </div>

        <div class="row text-portal-soft-black mt-3 mb-2">
            <div class="col priority-margin-bottom flex-display" v-once>
                <label for="anotherinstitution-name">
                    <strong>{{cmsContentBlocks['radiologyExamsCopy.AnotherInstitutionLabelLabel']}} </strong>
                </label>
            </div>
        </div>

        <div class="row text-portal-soft-black mb-2">
            <div class="col">
                <input id="another-institution-name" type="text" :placeholder="cmsContentBlocks['radiologyExamsCopy.AnotherInstitutionName.PH']" v-model="messageModel.anotherInstitutionName" v-error-message="{ errorModel: 'errorModel.anotherInstitutionName' }" class="form-control" maxlength="250" />
            </div>
        </div>

        <div class="row text-portal-soft-black mb-2">
            <div class="col">
                <input id="another-institution-contact-name" type="text" :placeholder="cmsContentBlocks['radiologyExamsCopy.AnotherInstitutionCN.PH']" v-model="messageModel.anotherInstitutionContactName" v-error-message="{ errorModel: 'errorModel.anotherInstitutionName' }" class="form-control" maxlength="250" />
            </div>
        </div>

        <div class="row d-none d-lg-block">
            <div class="col">
                <hr>
            </div>
        </div>

        <!--ExamType/Date#1-->
        <div class="row text-portal-soft-black mb-2">
            <div class="col-12 priority-margin-bottom flex-display" v-once>
                <label for="radiology-exam-type1"><strong>{{cmsContentBlocks['radiologyExamsCopy.ExamType1Label']}}<span class="required"> *</span></strong></label>
            </div>
            <div class="col">
                <select2-component id="radiology-exam-type1" title="Exam Type 1" v-error-message="{ errorModel: 'errorModel.radiologyExamsType1' }" v-model="messageModel.radiologyExamsType1" :options="radiologyExamsTypeValues" class="form-control" :allowclear="false" :addblankentry="false">
                </select2-component>
                <span class="invalid-feedback is-invalid">{{errorModel.radiologyExamsType1 | firstError}}</span>
            </div>
        </div>

        <div class="row text-portal-soft-black mb-2">
            <div class="col-12 priority-margin-bottom flex-display" v-once>
                <label for="radiology-exam-date1"><strong>{{cmsContentBlocks['radiologyExamsCopy.ExamDate1Label']}}</strong><span class="required"> *</span></label>
            </div>
            <div class="col">
                <div class="input-group">
                    <date-picker-component ref="calendar1"
                                           id="radiology-exam-date1"
                                           :typeable="true"
                                           v-error-message="{ errorModel: 'errorModel.radiologyExamDate1' }"
                                           class="form-control vdp-datepickerinput"
                                           placeholder="MM / DD / YYYY"
                                           format="MM/dd/yyyy"
                                           v-model="messageModel.radiologyExamDate1">
                    </date-picker-component>
                    <div class="input-group-append">
                        <div @click="$refs.calendar1.showCalendar()" class="input-group-text bg-white rounded-right">
                            <i class="far fa-calendar-alt text-primary"></i>
                        </div>
                    </div>
                    <span class="invalid-feedback is-invalid">{{ errorModel.radiologyExamDate1 | firstError }}</span>
                </div>
            </div>
        </div>

        <!--ExamType/Date#2-->
        <div class="row text-portal-soft-black mb-2">
            <div class="col-12 priority-margin-bottom flex-display" v-once>
                <label for="radiology-exam-type2"><strong>{{cmsContentBlocks['radiologyExamsCopy.ExamType2Label']}} </strong></label>
            </div>
            <div class="col">
                <select2-component id="radiology-exam-type2" title="Exam Type 2" v-model="messageModel.radiologyExamsType2" :options="radiologyExamsTypeValues" class="form-control" :allowclear="false" :addblankentry="false">
                </select2-component>
                <span class="invalid-feedback is-invalid">{{errorModel.radiologyExamsType2 | firstError}}</span>
            </div>
        </div>

        <div class="row text-portal-soft-black mb-2">
            <div class="col-12 priority-margin-bottom flex-display" v-once>
                <label for="radiology-exam-date2"><strong>{{cmsContentBlocks['radiologyExamsCopy.ExamDate2Label']}} </strong></label>
            </div>
            <div class="col">
                <div class="input-group">
                    <date-picker-component ref="calendar2"
                                           id="radiology-exam-date2"
                                           :typeable="true"
                                           v-error-message="{ errorModel: 'errorModel.radiologyExamDate2' }"
                                           class="form-control vdp-datepickerinput"
                                           placeholder="MM / DD / YYYY"
                                           format="MM/dd/yyyy"
                                           v-model="messageModel.radiologyExamDate2">
                    </date-picker-component>
                    <div class="input-group-append">
                        <div @click="$refs.calendar2.showCalendar()" class="input-group-text bg-white rounded-right">
                            <i class="far fa-calendar-alt text-primary"></i>
                        </div>
                    </div>
                    <span class="invalid-feedback is-invalid">{{ errorModel.radiologyExamDate2 | firstError }}</span>
                </div>
            </div>
        </div>

        <!--ExamType/Date#3-->
        <div class="row text-portal-soft-black mb-2">
            <div class="col-12 priority-margin-bottom flex-display" v-once>
                <label for="radiology-exam-type3"><strong>{{cmsContentBlocks['radiologyExamsCopy.ExamType3Label']}} </strong></label>
            </div>
            <div class="col">
                <select2-component id="radiology-exam-type3" title="Exam Type 3" v-model="messageModel.radiologyExamsType3" :options="radiologyExamsTypeValues" class="form-control" :allowclear="false" :addblankentry="false">
                </select2-component>
                <span class="invalid-feedback is-invalid">{{errorModel.radiologyExamsType3 | firstError}}</span>
            </div>
        </div>

        <div class="row text-portal-soft-black mb-2">
            <div class="col-12 priority-margin-bottom flex-display" v-once>
                <label for="radiology-exam-date3"><strong>{{cmsContentBlocks['radiologyExamsCopy.ExamDate3Label']}} </strong></label>
            </div>
            <div class="col">
                <div class="input-group">
                    <date-picker-component ref="calendar3"
                                           id="radiology-exam-date3"
                                           :typeable="true"
                                           v-error-message="{ errorModel: 'errorModel.radiologyExamDate3' }"
                                           class="form-control vdp-datepickerinput"
                                           placeholder="MM / DD / YYYY"
                                           format="MM/dd/yyyy"
                                           v-model="messageModel.radiologyExamDate3">
                    </date-picker-component>
                    <div class="input-group-append">
                        <div @click="$refs.calendar3.showCalendar()" class="input-group-text bg-white rounded-right">
                            <i class="far fa-calendar-alt text-primary"></i>
                        </div>
                    </div>
                    <span class="invalid-feedback is-invalid">{{ errorModel.radiologyExamDate3 | firstError }}</span>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <!--<banner-component v-if="nonEnglish" :bannerText="cmsContentBlocks.messageMustBeInEnglish"></banner-component>-->
                <message-body-component v-model="messageModel.messageBody"
                                        :error-model="errorModel"
                                        :cms-content-blocks="cmsContentBlocks"
                                        :non-english="nonEnglish"
                                        :text-area-style-object="{ height: '200px !important' }">
                </message-body-component>
            </div>
        </div>

        <!--<div class="row" style="display:none">
        <div class="col">
            <upload-component :attachment-group-id="attachmentGroupId">
                <template v-slot:multiple-error-slot>
                    <span class="invalid-feedback is-invalid d-inline">{{ errorModel.attachmentGroupId | firstError }}</span>
                </template>
            </upload-component>
        </div>
    </div>-->

    </div>
</template>

<script>

    import Vue from 'vue';
    import moment from 'moment';
    import Datepicker from 'vuejs-datepicker';

    import formattingDirective from '@SharedVueComponents/formatting/formattingdirective';
    import errorMessageDirective from '@SharedVueComponents/Validation/ErrorMessageDirective';
    import composeMessageBody from '../../Common/message.body.vue';
    import select2Component from '@SharedVueComponents/select2/select2.vue';
    import uploadComponent from '@PortalVueComponents/Uploader/file.multiple.uploader.vue';
    import { mask } from 'vue-the-mask'
    import { ReferenceDataHttpSvc } from '@SharedHttpServices/reference.data.httpservice';
    import { EthicsConsultationHttpSvc } from '@PortalHttpServices/portal.ethics.consultation.httpservice';
    import { PatientContactHttpSvc } from '@SharedHttpServices/contact.information.httpservice';
    import mskBanner from '@PortalVueComponents/Banner/msk.banner.vue';

    export default {
        name: 'radiologyExamsCopyTemplate',
        props: {
            physicianDropDown: { type: Array },
            attachmentGroupId: { type: String },
            errorModel: { type: Object },
            cmsContentBlocks: { type: Object },
            sendToThisMailbox: { type: String },
            preSelectedDefaultToMailboxId: { type: String },
            preSelectedDefaultToEmailId: { type: String },
            nonEnglish: { type: Boolean }
        },
        components: {
            'select2-component': select2Component,
            'message-body-component': composeMessageBody,
            'upload-component': uploadComponent,
            'date-picker-component': Datepicker,
            'banner-component': mskBanner
        },
        directives: {
            mask
        },
        data: function () {
            return {

                isSendingMessage: false,

                isPatient: true,

                radiologyExamsTypeValues: ['Cat Scan (CT)', 'MRI (MR)', 'Mammogram (MG)', 'Ultrasound (US)', 'X-Ray (CR/XR)', 'PET Scan (PT)'],
                radiologyExamsDeliveryValues: ['Electronically', 'CD/DVD'],

                showMailingAddress: '',

                patientContactInfo:
                {
                    patientFullName: '',
                    patientDOB: '',
                    patientMRN: '',
                    proxyFullName: '',
                    proxyRelationship: '',
                    proxyDOB: '',
                    proxyMRN: '',
                    proxyRelationship: '',
                    
                },

                messageModel: {
                    isPatient: true,
                    toMailboxId: this.preSelectedDefaultToMailboxId,
                    toEmailAddress: this.preSelectedDefaultToEmailId,
                    patientPhoneNumber: '',
                    patientEmailAddress: '',
                    patientMailingAddress: 'N/A',
                    proxyPhoneNumber: '',
                    proxyEmailAddress: '',
                    proxyMailingAddress: 'N/A',
                    radiologyExamsDeliveryType: 'Electronically',
                    radiologyExamsType1: '',
                    radiologyExamDate1: '',
                    radiologyExamsType2: '',
                    radiologyExamDate2: '',
                    radiologyExamsType3: '',
                    radiologyExamDate3: '',
                    anotherInstitutionName: '',
                    anotherInstitutionContactName: '',
                    messageBody: '',
                    attachmentGroupId: this.attachmentGroupId,
                }
            }
        },
        created: function () {

            EthicsConsultationHttpSvc.GetPatientandProxyContactData()
                .done(response => {
                    this.patientContactInfo.patientFullName = response.patientFullName;
                    this.patientContactInfo.proxyFullName = response.proxyFullName;
                    this.patientContactInfo.patientMRN = response.patientMRN;
                    this.patientContactInfo.proxyMRN = response.proxyMRN;
                    this.patientContactInfo.patientDOB = response.patientDOB;
                    this.patientContactInfo.proxyDOB = response.proxyDOB;
                    this.patientContactInfo.proxyRelationship = response.proxyRelationship;
                    this.isPatient = response.isPatient;
                    this.messageModel.patientEmailAddress = response.patientEmailAddress;
                    this.messageModel.proxyEmailAddress = response.proxyEmailAddress;
                    this.messageModel.patientPhoneNumber = "";
                    this.messageModel.proxyPhoneNumber = "";
                    this.messageModel.isPatient = response.isPatient;
                    this.messageModel.messageBody = null;
                });

            PatientContactHttpSvc.GetPatientContactInformation()
                .done(response => {
                    //this.patientContactInfo.patientDOB = response.dateOfBirth;
                    //this.patientContactInfo.proxyDOB = response.dateOfBirth;
                    this.messageModel.patientMailingAddress = (response.permAddress == '') ? "N/A" : this.buildAddress(response.permAddress);
                    this.messageModel.proxyMailingAddress = "N/A";
                });

        },
        mounted: function () {
            this.$emit('setMessageObject', this.messageModel);
        },
        watch: {

            messageModel: {
                handler: function (newValue) {
                    this.$emit('setMessageObject', newValue);
                },
                deep: true
            },

            preSelectedDefaultToMailboxId: function (newValue, oldValue) {
                this.messageModel.toMailboxId = newValue;
            },

            preSelectedDefaultToEmailId: function (newValue, oldValue) {
                this.messageModel.toEmailAddress = newValue;
            },

            'messageModel.radiologyExamsDeliveryType': function (newValue, oldValue) {
                Vue.delete(this.errorModel, 'patientEmailAddress');
                Vue.delete(this.errorModel, 'proxyEmailAddress');
                Vue.delete(this.errorModel, 'patientPhoneNumber');
                Vue.delete(this.errorModel, 'proxyPhoneNumber');
                Vue.delete(this.errorModel, 'patientMailingAddress');
                Vue.delete(this.errorModel, 'proxyMailingAddress');
                if (newValue == 'Electronically')
                {
                    this.showMailingAddress = false;
                }
                else
                {
                    this.showMailingAddress = true;
                }
            },
            'messageModel.patientEmailAddress': function (newValue, oldValue) {
                //clear any errors
                Vue.delete(this.errorModel, 'patientEmailAddress');
            },
            'messageModel.proxyEmailAddress': function (newValue, oldValue) {
                //clear any errors
                Vue.delete(this.errorModel, 'proxyEmailAddress');
            },
            'messageModel.patientMailingAddress': function (newValue, oldValue) {
                //clear any errors
                Vue.delete(this.errorModel, 'patientMailingAddress');
            },
            'messageModel.proxyMailingAddress': function (newValue, oldValue) {
                //clear any errors
                Vue.delete(this.errorModel, 'proxyMailingAddress');
            },
            'messageModel.patientPhoneNumber': function (newValue, oldValue) {
                //clear any errors
                Vue.delete(this.errorModel, 'patientPhoneNumber');
            },
            'messageModel.proxyPhoneNumber': function (newValue, oldValue) {
                //clear any errors
                Vue.delete(this.errorModel, 'proxyPhoneNumber');
            },
        },
        methods: {
            buildAddress: function (permAddress) {
                var addr = permAddress;
                if (!addr) return "N/A";
                var result = [];
                if (addr.address1) {
                    result.push(addr.address1);
                }
                if (addr.address2) {
                    result.push(addr.address2);
                }
                if (addr.city) {
                    result.push(addr.city);
                }
                var stateZip = [];
                if (addr.state && addr.state.trim()) {
                    stateZip.push(addr.state);
                }
                if (addr.zip) {
                    stateZip.push(addr.zip);
                }
                var address = result.join(', ');
                if (stateZip.length > 0) {
                    address = result.length > 0 ? address + ", " : address;
                    address = address + stateZip.join(' ');
                }
                return address;
            },

        }
    };
</script>

